import { useIntl } from 'react-intl';
import { TABLE_HEIGHT } from 'common/constants';
import { ComposedTable } from 'components/ComposedTable';
import { PaymentDetailsTable, VendorPaymentDetails } from '../../types';
import { completedPaymentTableColumns } from '../../vendorPaymentDetailsColumns';
import { SuccessTableHeader } from '../SuccessTableHeader/SuccessTableHeader';

export const VendorPaymentSuccessTable = ({
  data,
  tableHeaderTitle
}: PaymentDetailsTable): React.JSX.Element => {
  const intl = useIntl();
  return (
    <ComposedTable<VendorPaymentDetails>
      columnDefs={completedPaymentTableColumns(intl)}
      rowData={data}
      tableHeaderTitle={tableHeaderTitle}
      useCustomHeader
      customHeight={TABLE_HEIGHT}
      customHeaderContent={gridRef => (
        <SuccessTableHeader
          tableHeaderTitle={tableHeaderTitle}
          totalRecord={data?.length || 0}
          gridRef={gridRef}
          columnDefs={completedPaymentTableColumns(intl)}
        />
      )}
      getRowId={param => param.data.vendorNo}
    />
  );
};
